<template>
  <div>
    <div style="display:none">
      <input type="file" id="f1" @change="fileImg" />
    </div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 视频管理 / 视频列表 / 编辑视频</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              视频缩略图
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <img :src="showImg" style="width: 100px;cursor:pointer;" onclick="f1.click()" />
              （用于APP显示）
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>视频地址
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="url" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>序列号
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="num" class="boxText"/>
            </td>
          </tr>

        </table>
      </div>

      <div style="padding-top: 15px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="保存" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, FILE_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";
import axios from "axios";
import router from "@/router";

export default {
  name: "AddVedio",
  data(){
    return{
      id:0,
      url: "",
      num: "0",
      nickName: "",
      department: "",
      authorityGroup: "",
      awardImg:"",
      showImg:"",
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    let json=JSON.parse(localStorage.getItem("UPDATEOBJ"))
    console.log(json)
    this.id=json.vedioId
    this.url=json.vedioUrl
    this.awardImg=json.vedioImg
    this.num=json.vedioNum
    if(this.awardImg==""){
      this.showImg=require('@/assets/fileImg.png')
    }else{
      this.showImg=FILE_URL+this.awardImg
    }
  },
  methods: {
    fileImg(){
      let that=this
      var formData=new FormData()
      formData.append("files",document.querySelector("#f1").files[0])
      axios.post(DO_NET_URL+"other/UploadImg", formData, {
        headers: {
          token: localStorage.getItem("iwa_token"),
          'Content-Type': "multipart/form-data",
          'timestamp': new Date().getTime(),
          'accreditToken': localStorage.getItem("accreditToken"),
        }
      }).then(response => {
        if (response.data.data == "请登录！") {
          setTimeout(function () {
            router.replace('index')
          }, 600);
        } else {

          console.log(response.data);
          var v=response.data
          if(v.code==200){
            toask("上传成功！",6)
            that.showImg=FILE_URL+v.data.img
            that.awardImg=v.data.img
          }else{
            toask(v.data,6)
          }
        }

      }).catch(error => {
        // 处理错误情况
        console.error(error);
      });
    },
    setAut(key){
      if(this.data.authorityGroup.indexOf("|"+key+",")!=-1){
        this.data.authorityGroup=this.data.authorityGroup.replace("|"+key+",","")
      }else{
        this.data.authorityGroup+="|"+key+","
      }
      console.log(this.data.authorityGroup)
    },
    addAdmin(){
      let that=this
      if(this.url==""){
        toask("请输入视频地址！",6)
        return
      }
      if(this.awardImg==""){
        toask("请输入上传视频缩略图！",6)
        return
      }
      if(this.num==""){
        toask("请输入序列号！",6)
        return
      }
      loading("请求中")
      axiosPost(DO_NET_URL+"vedio/UpdateVedio?id="+this.id+"&img="+this.awardImg+"&url="+this.url+"&num="+this.num,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("保存成功",6)
          setTimeout(function (){
            that.$emit("send",'vedioList')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'vedioList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>